module.exports = "/images/data-preview.png?aacbaa93c806a7140bfdc304d76f7855";